import { createFileRoute } from '@tanstack/react-router'

import { FundsOverview } from '@/components/FundsOverview'

export const Route = createFileRoute('/_app/funds/')({
  component: FundsPage,
})

function FundsPage() {
  return <FundsOverview />
}
